import { SectionTitle, SectorItem } from "./components";
import { OurSectorsSectionMobile } from "./components/OurSectorsSectionMobile";
import { sectorColors } from "./data";
import { useSectorHover } from "./hooks";

export function OurSectorsSection() {
  const { hovered, setHovered, getImageWidth, isHovered, isMobile } =
    useSectorHover();

  return (
    <section className="bg-dark-blue">
      <div className="relative mx-auto max-w-[2200px] overflow-hidden transition-all duration-700 max-lg:hidden">
        <SectionTitle isVisible={hovered === null} />

        <div className="flex min-w-full max-lg:flex-col max-lg:gap-0 lg:h-[75vh]">
          {sectorColors.map((sector, index) => (
            <SectorItem
              key={index}
              sector={sector}
              index={index}
              isHovered={isHovered(index)}
              imageWidth={getImageWidth(index)}
              onMouseEnter={() => !isMobile && setHovered(index)}
              onMouseLeave={() => !isMobile && setHovered(null)}
              onClick={() =>
                isMobile && setHovered(hovered === index ? null : index)
              }
              isMobile={isMobile}
            />
          ))}
        </div>
      </div>
      <OurSectorsSectionMobile data={sectorColors} />
    </section>
  );
}
